module.exports = __webpack_public_path__ + "img/course (1).8b2e8cea.png";